// extracted by mini-css-extract-plugin
export var cancelButton = "_pz-5";
export var content = "_pz-3";
export var createButton = "_pz-6";
export var drawerContainer = "_pz-0";
export var footer = "_pz-2";
export var header = "_pz-1";
export var orderFormColumn = "_pz-4";